export enum Permission {
    POS_PEER_IMPORT = 'posPeerImport',
  USERS_VIEW = 'usersView',
  USERS_EDIT = 'usersEdit',
  RECORD_VIEW = 'recordView',
  USERS_DELETE = 'usersDelete',
  USERS_ADD = 'usersAdd',
  PERMISSIONS_EDIT = 'permissionsEdit',
  PERMISSIONS_VIEW = 'permissionsView',
  PERMISSIONS_DELETE = 'permissionsDelete',
  PERMISSIONS_ADD = 'permissionsAdd',
  PRODUCTS_DELETE = 'productsDelete',
  PRODUCTS_VIEW = 'productsView',
  BARCODE_VIEW = 'barcodeView',
  PRODUCTS_EDIT = 'productsEdit',
  PRODUCTS_ADD = 'productsAdd',
  EXPENSE_ADD = 'expenseAdd',
  EXPENSE_DELETE = 'expenseDelete',
  EXPENSE_EDIT = 'expenseEdit',
  EXPENSE_VIEW = 'expenseView',
  TRANSFER_DELETE = 'transferDelete',
  TRANSFER_ADD = 'transferAdd',
  TRANSFER_VIEW = 'transferView',
  TRANSFER_EDIT = 'transferEdit',
  ADJUSTMENT_DELETE = 'adjustmentDelete',
  ADJUSTMENT_ADD = 'adjustmentAdd',
  ADJUSTMENT_EDIT = 'adjustmentEdit',
  ADJUSTMENT_VIEW = 'adjustmentView',
  SALES_EDIT = 'salesEdit',
  SALES_VIEW = 'salesView',
  SALES_DELETE = 'salesDelete',
  SALES_ADD = 'salesAdd',
  PURCHASES_EDIT = 'purchasesEdit',
  PURCHASES_VIEW = 'purchasesView',
  PURCHASES_DELETE = 'purchasesDelete',
  PURCHASES_ADD = 'purchasesAdd',
  QUOTATIONS_EDIT = 'quotationsEdit',
  QUOTATIONS_DELETE = 'quotationsDelete',
  QUOTATIONS_ADD = 'quotationsAdd',
  QUOTATIONS_VIEW = 'quotationsView',
  PAYMENT_SALES_DELETE = 'paymentSalesDelete',
  PAYMENT_SALES_ADD = 'paymentSalesAdd',
  PAYMENT_SALES_EDIT = 'paymentSalesEdit',
  PAYMENT_SALES_VIEW = 'paymentSalesView',
  PURCHASE_RETURNS_DELETE = 'purchaseReturnsDelete',
  PURCHASE_RETURNS_ADD = 'purchaseReturnsAdd',
  PURCHASE_RETURNS_VIEW = 'purchaseReturnsView',
  PURCHASE_RETURNS_EDIT = 'purchaseReturnsEdit',
  SALE_RETURNS_DELETE = 'saleReturnsDelete',
  SALE_RETURNS_ADD = 'saleReturnsAdd',
  SALE_RETURNS_EDIT = 'saleReturnsEdit',
  SALE_RETURNS_VIEW = 'saleReturnsView',
  PAYMENT_PURCHASES_EDIT = 'paymentPurchasesEdit',
  PAYMENT_PURCHASES_VIEW = 'paymentPurchasesView',
  PAYMENT_PURCHASES_DELETE = 'paymentPurchasesDelete',
  PAYMENT_PURCHASES_ADD = 'paymentPurchasesAdd',
  PAYMENT_RETURNS_EDIT = 'paymentReturnsEdit',
  PAYMENT_RETURNS_VIEW = 'paymentReturnsView',
  PAYMENT_RETURNS_DELETE = 'paymentReturnsDelete',
  PAYMENT_RETURNS_ADD = 'paymentReturnsAdd',
  CUSTOMERS_EDIT = 'customersEdit',
  CUSTOMERS_VIEW = 'customersView',
  CUSTOMERS_DELETE = 'customersDelete',
  CUSTOMERS_ADD = 'customersAdd',
  UNIT = 'unit',
  CURRENCY = 'currency',
  CATEGORY = 'category',
  BACKUP = 'backup',
  WAREHOUSE = 'warehouse',
  BRAND = 'brand',
  SETTING_SYSTEM = 'settingSystem',
  ACCOUNTING_SETTINGS = 'accountingSettings',
  WAREHOUSE_REPORT = 'warehouseReport',
  REPORTS_QUANTITY_ALERTS = 'reportsQuantityAlerts',
  REPORTS_PROFIT = 'reportsProfit',
  REPORTS_SUPPLIERS = 'reportsSuppliers',
  REPORTS_CUSTOMERS = 'reportsCustomers',
  REPORTS_PURCHASE = 'reportsPurchase',
  REPORTS_SALES = 'reportsSales',
  REPORTS_PAYMENTS_PURCHASE_RETURN = 'reportsPaymentsPurchaseReturn',
  REPORTS_PAYMENTS_SALE_RETURNS = 'reportsPaymentsSaleReturns',
  REPORTS_PAYMENTS_PURCHASES = 'reportsPaymentsPurchases',
  REPORTS_PAYMENTS_SALES = 'reportsPaymentsSales',
  SUPPLIERS_DELETE = 'suppliersDelete',
  SUPPLIERS_ADD = 'suppliersAdd',
  SUPPLIERS_EDIT = 'suppliersEdit',
  SUPPLIERS_VIEW = 'suppliersView',
  POS_VIEW = 'posView',
  POS_CREATE = 'Pos_create',
  POS_DELETE = 'Pos_delete',
  PAYMENT_GATEWAY = 'paymentGateway',
  PRODUCT_IMPORT = 'productImport',
  CUSTOMERS_IMPORT = 'customersImport',
  SUPPLIERS_IMPORT = 'suppliersImport',
  VIEW_EMPLOYEE = 'viewEmployee',
  ADD_EMPLOYEE = 'addEmployee',
  EDIT_EMPLOYEE = 'editEmployee',
  DELETE_EMPLOYEE = 'deleteEmployee',
  COMPANY = 'company',
  DEPARTMENT = 'department',
  DESIGNATION = 'designation',
  OFFICE_SHIFT = 'officeShift',
  ATTENDANCE = 'attendance',
  LEAVE = 'leave',
  HOLIDAY = 'holiday',
  TOP_PRODUCTS = 'topProducts',
  TOP_CUSTOMERS = 'topCustomers',
  SHIPMENT = 'shipment',
  USERS_REPORT = 'usersReport',
  STOCK_REPORT = 'stockReport',
  SMS_SETTINGS = 'smsSettings',
  POS_SETTINGS = 'posSettings',
  MAIL_SETTINGS = 'mailSettings',
  DASHBOARD = 'dashboard',
  PAY_DUE = 'payDue',
  PAY_SALE_RETURN_DUE = 'paySaleReturnDue',
  PAY_SUPPLIER_DUE = 'paySupplierDue',
  PAY_PURCHASE_RETURN_DUE = 'payPurchaseReturnDue',
  PRODUCT_REPORT = 'productReport',
  PRODUCT_SALES_REPORT = 'productSalesReport',
  PRODUCT_PURCHASES_REPORT = 'productPurchasesReport',
  NOTIFICATION_TEMPLATE = 'notificationTemplate',
  EDIT_PRODUCT_SALE = 'editProductSale',
  EDIT_PRODUCT_PURCHASE = 'editProductPurchase',
  EDIT_PRODUCT_QUOTATION = 'editProductQuotation',
  EDIT_TAX_DISCOUNT_SHIPPING_SALE = 'editTaxDiscountShippingSale',
  EDIT_TAX_DISCOUNT_SHIPPING_PURCHASE = 'editTaxDiscountShippingPurchase',
  EDIT_TAX_DISCOUNT_SHIPPING_QUOTATION = 'editTaxDiscountShippingQuotation',
  MODULE_SETTINGS = 'moduleSettings',
  COUNT_STOCK = 'countStock',
  DEPOSIT_ADD = 'depositAdd',
  DEPOSIT_DELETE = 'depositDelete',
  DEPOSIT_EDIT = 'depositEdit',
  DEPOSIT_VIEW = 'depositView',
  ACCOUNT = 'account',
  INVENTORY_VALUATION = 'inventoryValuation',
  EXPENSES_REPORT = 'expensesReport',
  DEPOSITS_REPORT = 'depositsReport',
  TRANSFER_MONEY = 'transferMoney',
  PAYROLL = 'payroll',
  PROJECTS = 'projects',
  TASKS = 'tasks',
  FIXED_ASSET_VIEW = 'fixedAssetView',
  FIXED_ASSET_ADD = 'fixedAssetAdd',
  FIXED_ASSET_EDIT = 'fixedAssetEdit',
  FIXED_ASSET_DELETE = 'fixedAssetDelete',
  FIXED_ASSET_CATEGORY = 'fixedAssetCategory',
  FIXED_ASSET_LOCATION = 'fixedAssetLocation',
  PERSONAL_WITHDRAWAL_VIEW = 'personalWithdrawalView',
  PERSONAL_WITHDRAWAL_ADD = 'personalWithdrawalAdd',
  PERSONAL_WITHDRAWAL_EDIT = 'personalWithdrawalEdit',
  PERSONAL_WITHDRAWAL_DELETE = 'personalWithdrawalDelete',
  CASH_WITHDRAWAL_VIEW = 'cashWithdrawalView',
  CASH_WITHDRAWAL_ADD = 'cashWithdrawalAdd',
  CASH_WITHDRAWAL_EDIT = 'cashWithdrawalEdit',
  CASH_WITHDRAWAL_DELETE = 'cashWithdrawalDelete',
  CUSTODY_VIEW = 'custodyView',
  CUSTODY_ADD = 'custodyAdd',
  CUSTODY_EDIT = 'custodyEdit',
  CUSTODY_DELETE = 'custodyDelete',
  REPORTS_INCOME_STATEMENT = 'reportsIncomeStatement',
  REPORTS_BALANCE_SHEET = 'reportsBalanceSheet',
  SETUP_OPENING_INVENTORY = 'setupOpeningInventory',
  COMMIT_OPENING_SUPPLIERS = 'commitOpeningSuppliers',
  COMMIT_OPENING_CUSTOMERS = 'commitOpeningCustomers',
  COMMIT_OPENING_WAREHOUSES = 'commitOpeningWarehouses',
  COMMIT_OPENING_ACCOUNTS = 'commitOpeningAccounts',
  COMMIT_OPENING_CATEGORIES = 'commitOpeningCategories',
  COMMIT_OPENING_FIXED_ASSETS = 'commitOpeningFixedAssets',
  COMMIT_OPENING_PRODUCTS = 'commitOpeningProducts',
  FINALIZE_INVENTORY_SETUP = 'finalizeInventorySetup',
  OPENING_STORE_ACCESS = 'openingStoreAccess',
  PAYMENT_VIEW_ALL = 'paymentViewAll',
  PAYMENT_ADD = 'paymentAdd',
  PAYMENT_EDIT = 'paymentEdit',
  PAYMENT_DELETE = 'paymentDelete',
  DRAFT_JOURNAL = 'draftJournal',
  REPORTS_VIEW_AI = 'reportsViewAi',
  REPORTS_FINANCIAL = 'reportsFinancial',
  COST_CENTER_VIEW = 'costCenterView',
  COST_CENTER_CREATE = 'costCenterCreate',
  COST_CENTER_UPDATE = 'costCenterUpdate',
  COST_CENTER_DELETE = 'costCenterDelete',
  FISCAL_PERIOD_VIEW = 'fiscalPeriodView',
  FISCAL_PERIOD_CREATE = 'fiscalPeriodCreate',
  FISCAL_PERIOD_CLOSE = 'fiscalPeriodClose',
  FISCAL_PERIOD_REOPEN = 'fiscalPeriodReopen',
  FISCAL_PERIOD_FORCE_CLOSE = 'fiscalPeriodForceClose',
  FISCAL_PERIOD_CARRY_FORWARD = 'fiscalPeriodCarryForward',
  JOURNAL_VIEW = 'journalView',
  JOURNAL_CREATE = 'journalCreate',
  JOURNAL_POST = 'journalPost',
  JOURNAL_APPROVE = 'journalApprove',
  JOURNAL_UPDATE = 'journalUpdate',
  JOURNAL_DELETE = 'journalDelete',
  ACCRUAL_TEMPLATE_VIEW = 'accrualTemplateView',
  ACCRUAL_TEMPLATE_CREATE = 'accrualTemplateCreate',
  ACCRUAL_TEMPLATE_UPDATE = 'accrualTemplateUpdate',
  ACCRUAL_TEMPLATE_DELETE = 'accrualTemplateDelete',
  BANK_RECONCILIATION_VIEW = 'bankReconciliationView',
  BANK_RECONCILIATION_CREATE = 'bankReconciliationCreate',
  BANK_RECONCILIATION_UPDATE = 'bankReconciliationUpdate',
  BANK_RECONCILIATION_DELETE = 'bankReconciliationDelete',
  ACCOUNTING_STATEMENT_GENERATE = 'accountingStatementGenerate',
  PAYROLL_COMPONENT_VIEW = 'payrollComponentView',
  PAYROLL_COMPONENT_ADD = 'payrollComponentAdd',
  PAYROLL_COMPONENT_EDIT = 'payrollComponentEdit',
  PAYROLL_COMPONENT_DELETE = 'payrollComponentDelete',
  PAYROLL_RUN_VIEW = 'payrollRunView',
  PAYROLL_RUN_CREATE = 'payrollRunCreate',
  PAYROLL_RUN_APPROVE = 'payrollRunApprove',
  PAYROLL_RUN_POST = 'payrollRunPost',
  PAYROLL_DISBURSE = 'payrollDisburse',
  PAYROLL_TRANSFER_GENERATE = 'payrollTransferGenerate',
  PAYROLL_SENSITIVE_VIEW = 'payrollSensitiveView',
  PAYROLL_EXPORT = 'payrollExport',
  PAYROLL_PERIOD_VIEW = 'payrollPeriodView',
  PAYROLL_PERIOD_CREATE = 'payrollPeriodCreate',
  PAYROLL_PERIOD_CLOSE = 'payrollPeriodClose',
  PAYROLL_SETTINGS_VIEW = 'payrollSettingsView',
  PAYROLL_SETTINGS_EDIT = 'payrollSettingsEdit',
  SALARY_SETUP_VIEW = 'salarySetupView',
  SALARY_SETUP_EDIT = 'salarySetupEdit',
  EMPLOYEE_LOAN_VIEW = 'employeeLoanView',
  EMPLOYEE_LOAN_ADD = 'employeeLoanAdd',
  EMPLOYEE_LOAN_EDIT = 'employeeLoanEdit',
  EMPLOYEE_LOAN_APPROVE = 'employeeLoanApprove',
  EOSB_VIEW = 'eosbView',
  EOSB_PROVISION_VIEW = 'eosbProvisionView',
  EOSB_PROVISION_POST = 'eosbProvisionPost',
  EOSB_SETTLEMENT_VIEW = 'eosbSettlementView',
  EOSB_SETTLEMENT_APPROVE = 'eosbSettlementApprove',
  EOSB_SETTLEMENT_POST = 'eosbSettlementPost',
  LEAVE_PROVISION_VIEW = 'leaveProvisionView',
  LEAVE_PROVISION_CREATE = 'leaveProvisionCreate',
  LEAVE_PROVISION_POST = 'leaveProvisionPost',
  PAYROLL_REPORT_VIEW = 'payrollReportView',
  PAYROLL_REPORT_GENERATE = 'payrollReportGenerate',
  JOURNAL_REVERSE = 'journalReverse',
  BUDGETS_VIEW = 'budgetsView',
  BUDGETS_ADD = 'budgetsAdd',
  BUDGETS_EDIT = 'budgetsEdit',
  BUDGETS_DELETE = 'budgetsDelete',
  BUDGETS_APPROVE = 'budgetsApprove',
  PAYMENT_FINALIZE = 'payment_finalize',
  ATTENDANCE_VIEW = 'attendanceView',
  AUDITLOG_VIEW = 'auditLogView',
  CUSTOMER_ADD = 'customerAdd',
  JOURNAL_EDIT = 'journalEdit',
  JOURNAL_FINALIZEALL = 'journalFinalizeall',
  JOURNAL_VIEWANY = 'journalViewAny',
  LEAVE_EDIT = 'leaveEdit',
  LEAVE_TYPE_DELETE = 'leaveTypeDelete',
  LEAVE_TYPE_EDIT = 'leaveTypeEdit',
  PAYMENT_FINALIZEBATCH = 'paymentFinalizebatch',
  PAYMENT_VIEW = 'paymentView',
  PAYMENT_VIEWANY = 'paymentViewAny',
  PURCHASES_IMPORT = 'purchasesImport',
  RECORD_CHECK = 'recordCheck',
  SALES_POS = 'salesPos',
  TRANSFERMONEY_VIEW = 'transfermoneyView',
  TRANSFER_MONEY_DELETE = 'transferMoneyDelete',
  TRANSFER_MONEY_EDIT = 'transferMoneyEdit',
  UNIT_EDIT = 'unitEdit',
  VIEW_ALL_RECORDS = 'viewAllRecords',
  WEBHOOK_DELETE = 'webhookDelete',
  WEBHOOK_EDIT = 'webhookEdit',
  WEBHOOK_VIEW = 'webhookView',
  AI_CHAT_USE = 'aiChatUse',
  AI_CONVERSATIONS_VIEW = 'aiConversationsView',
  AI_ACTION_APPROVE = 'aiActionApprove',
  AI_VISION_SCAN = 'aiVisionScan',
  BOT_CHANNELS_MANAGE = 'botChannelsManage',
  BOT_LIVE_CHAT_USE = 'botLiveChatUse',
  BOT_TEMPLATES_MANAGE = 'botTemplatesManage',
  BOT_AUTO_REPLIES_MANAGE = 'botAutoRepliesManage',
  GROUP_FINANCE_VIEW = 'groupFinanceView',
  BOOKS_VIEW = 'booksView',
  BOOKS_PREPARE = 'booksPrepare',
  BOOKS_APPROVE = 'booksApprove',
  INTERCOMPANY_VIEW = 'intercompanyView',
  INTERCOMPANY_PREPARE = 'intercompanyPrepare',
  INTERCOMPANY_APPROVE = 'intercompanyApprove',
  GROUP_FINANCE_PREPARE = 'groupFinancePrepare',
  GROUP_FINANCE_APPROVE = 'groupFinanceApprove',
  GROUP_FINANCE_PUBLISH = 'groupFinancePublish',
}
